import SearchSuggestion from './SearchSuggestion'
import { $1, debounce } from '../util'

/**
 * @module EventsSearch
 */
const EventsSearch = (() => {
  let searchSelector = null
  let searchFormSelector = null

  /**
   * @function init
   */
  const init = () => {
    searchSelector = $1('.js-events-search')
    searchFormSelector = $1('.js-events-search-form')
    if (!searchSelector || !searchFormSelector) return

    const cities = JSON.parse($1('.js-events-search-cities').getAttribute('data-cities'))

    searchSelector.addEventListener('keyup', debounce(() => {
      if (searchSelector.value.length < 1) {
        SearchSuggestion.hideAll()
        return
      }
 
      let results = cities.filter((c) => c.toUpperCase().includes(searchSelector.value.toUpperCase()))
      if (!results || results.length < 1) {
        SearchSuggestion.hideAll()
        return
      }

      results = results.map((r) => ({ label: r, value: r }))
      SearchSuggestion.show(searchSelector, results, (result) => {
        searchSelector.value = result.value
        searchFormSelector.submit()
        SearchSuggestion.hideAll()
      })
    }, 250))
  }

  return {
    init
  }
})()

export default EventsSearch



// WEBPACK FOOTER //
// app/javascript/scripts/components/EventsSearch.js